export default "__VITE_ASSET__BGKso16G__"